module.exports = __webpack_public_path__ + "assets/spinner-04853d.svg";